import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ModalRowContainer = styled.div`
    margin: 15px 0;
    display: flex;
    align-item: flex-start;

    label {
        flex: 1;
        margin-right: 15px;
    }

    div {
        flex: 2;
    }

`;

const SearchFormModalContent = ({
    Title,
    Description,
    Format,
    Example,
    RequiredByUSDOJOrder
}) => (
    <React.Fragment>
        <ModalRowContainer>
            <label>Label:</label>
            <div>{Title}</div>
        </ModalRowContainer>
        <ModalRowContainer>
            <label>Description:</label>
            <div>{Description}</div>
        </ModalRowContainer>
        <ModalRowContainer>
            <label>Format:</label>
            <div>{Format}</div>
        </ModalRowContainer>
        <ModalRowContainer>
            <label>Example:</label>
            <div dangerouslySetInnerHTML={{__html: Example}}></div>
        </ModalRowContainer>
        <ModalRowContainer>
            <label>Required by US DOJ Order:</label>
            <div>{RequiredByUSDOJOrder}</div>
        </ModalRowContainer>
    </React.Fragment> 
);

SearchFormModalContent.propTypes = {
    Title: PropTypes.string,
    Description: PropTypes.string,
    Format: PropTypes.string,
    Example: PropTypes.string,
    RequiredByUSDOJOrder: PropTypes.string,
}

export default SearchFormModalContent;


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormModalContent.js